import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        else if (to.hash) return { selector: to.hash }
        else if (from.path === to.path) return {}

        return {
            top: 1,
            behavior: 'smooth'
        }
    },
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: () => import('@/views/Dashboard.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/users',
            name: 'users',
            component: () => import('@/views/User/Users.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/profile',
            name: 'profile',
            component: () => import('@/views/Profile/Profile.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pos-hardware',
            name: 'pos-hardware',
            component: () => import('@/views/POSHardware/POSHardware.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/Login.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/resellers',
            name: 'resellers',
            component: () => import('@/views/Reseller/Resellers.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/resellers/:id',
            name: 'reseller',
            component: () => import('@/views/Reseller/Reseller.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/current-software',
            name: 'current-software',
            component: () => import('@/views/currentSoftware/CurrentSoftware.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/lead-sources',
            name: 'lead-sources',
            component: () => import('@/views/leadSource/LeadSources.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/card-payment-equipments',
            name: 'card-payment-equipments',
            component: () => import('@/views/cardPaymentEquipment/CardPaymentEquipments.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/'
        }
    ]
})

router.beforeEach((to, from, next) => {
    const loggedIn: boolean = isAuthenticated()
    const appStore = useAppStore()

    if (loggedIn && to.name === 'login') {
        next({ name: 'dashboard' })
        return
    }

    if (to.meta.requiresAuth && !isAuthenticated()) {
        appStore.setLogout()
        next({ name: 'login' })
    }

    next()
})

export default router
